import { ConnectError, createPromiseClient } from "@connectrpc/connect";
import type { ServiceType } from "@bufbuild/protobuf";
import { createClientCache, createTransport } from "@fox1ck-org/auth/connect";

import { auth } from "./auth";

/**
 * One transport: bearer from the session and, on a 401, a silent renew with
 * one replay before leaving for Keycloak. Failures reach the screens as the
 * ConnectError the server sent — code, `X-Field` metadata and FieldError
 * details intact. The package's `fieldErrors` wrapper is deliberately off: its
 * FieldConnectError is not a ConnectError, so connect re-normalised it into
 * `[unknown]` with no metadata and every field error and code was lost.
 */
const transport = createTransport({
  auth,
  retry: false,
  onUnauthenticated: "renew-then-login",
});

const cached = createClientCache(transport);

/** Typed Connect RPC client for generated tracker.v1 services. */
export function createClient<T extends ServiceType>(service: T) {
  return cached(service, createPromiseClient);
}

/** The field the server blamed (`X-Field` metadata of a refused write), if any. */
export function fieldFromError(err: unknown): string | undefined {
  if (!(err instanceof ConnectError)) return undefined;
  return err.metadata.get("X-Field") || undefined;
}
